import { Tab } from "@headlessui/react";
import SettingsTabNames from "../SettingsTabName/SettingsTabName";
// import { SettingsTabName } from "../SettingsTabName/SettingsTabName";
import UpdateRoom from "../UpdateRoom/UpdateRoom";

const SettingsTabs = () => {
  return (
    <div className="w-full px-2 lg:px-0">
      <Tab.Group>
        <div className="sm:flex space-x-5">
          <div className="">
            <Tab.List className="flex flex-col space-y-5 w-full">
              {/* < tabName="Dashboard" /> */}
              <SettingsTabNames tabName="room" />
            </Tab.List>
          </div>
          <div className="border border-gray-300 shadow w-full rounded-md">
            <Tab.Panels>
              <Tab.Panel>
                <UpdateRoom />
              </Tab.Panel>
            </Tab.Panels>
          </div>
        </div>
      </Tab.Group>
    </div>
  );
};

export default SettingsTabs;
